import React from 'react';
import { Fieldset, RadioButton } from '@fourthwall/components';
import { getEmojiIcon } from '../../../../utils';
import { FormFields } from '../../hooks/useBadgeForm/types';
import { EmojiInput } from '../EmojiInput';
import { MainInputs } from '../MainInputs';
export const BadgeType = ({ form }) => {
    if (form.values.badgeType === 'Verified') {
        return (React.createElement(Fieldset.Row, null,
            React.createElement(MainInputs, { form: form, verified: true })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Fieldset.Row, null,
            React.createElement(RadioButton, { label: "Icon and text", ...form.getFieldProps(FormFields.badgeType), checkedValue: "IconAndText" })),
        form.values.badgeType === 'IconAndText' && (React.createElement(Fieldset.Row, { inner: true },
            React.createElement(MainInputs, { form: form }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(RadioButton, { label: "Icon only", ...form.getFieldProps(FormFields.badgeType), checkedValue: "IconOnly" })),
        form.values.badgeType === 'IconOnly' && (React.createElement(Fieldset.Row, { inner: true },
            React.createElement(EmojiInput, { emoji: getEmojiIcon(form.values.emoji), onChange: (emoji) => {
                    if (emoji.type === 'ImageResource') {
                        form.setFieldValue(FormFields.emoji, {
                            type: 'ImageResource',
                            url: emoji.url,
                            imageResourceId: emoji.imageResourceId,
                        });
                    }
                    else {
                        form.setFieldValue(FormFields.emoji, {
                            type: 'Emoji',
                            emojiIcon: emoji.emojiIcon,
                        });
                    }
                } })))));
};
